import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
} from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const TopSpendersTable = ({ data = [], loading }) => {
  return (
    <Paper elevation={2} sx={{ height: 360, p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle1" gutterBottom>
        Top clientes por gasto
      </Typography>
      <TableContainer sx={{ overflowY: 'auto', flex: 1 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: 'background.paper' }}>Cliente</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'background.paper' }}>Total gastado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              [...Array(5)].map((_, i) => (
                <TableRow key={i}>
                  <TableCell><Skeleton width="80%" /></TableCell>
                  <TableCell align="right"><Skeleton width="50%" /></TableCell>
                </TableRow>
              ))
            ) : data.length > 0 ? (
              data.map((client, idx) => (
                <TableRow key={idx}>
                  <TableCell>{client.name}</TableCell>
                  <TableCell align="right">{formatMoney(client.totalSpent)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  <Typography variant="body2" color="textSecondary">
                    No hay datos disponibles.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default TopSpendersTable;
